import Link from 'next/link';

import { staticMediaUrl } from '@/fo/util/image-loader';
import { reachMetrikaGoal } from '@/fo/util/metrics';

import { styles } from './BuyNow.styles';

const media = (path: string) =>
  staticMediaUrl(`landing/bioderma-hydrabio/${path}`);

export interface BuyNowProps {
  isNearFooter?: boolean;
}

export function BuyNow({ isNearFooter = false }: BuyNowProps) {
  const slots = styles();

  if (isNearFooter) return null;

  return (
    <Link
      href="/catalog/bioderma/gammy/hydrabio/"
      target="_blank"
      className={slots.base()}
      onClick={() => {
        reachMetrikaGoal('knopka_kupit_seychas_kruglyash');
      }}
    >
      <picture>
        <source
          srcSet={media('buy-now-mobile.png')}
          media="(max-width: 767px)"
        />
        <img
          className={slots.image()}
          src={media('buy-now.png')}
          alt="Купить сейчас"
        />
      </picture>
      <img
        className={slots.hover()}
        src={media('buy-now-hover.png')}
        alt="Купить сейчас"
      />
    </Link>
  );
}
